export default __webpack_public_path__ + "static/Plots0076-d5306f485c69f8204ee80152c25c826f.jpg";